import { Directive, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { PlatformService } from '@app/shared/services/platform/platform.service';

@Directive({
  selector: '[vcObserve]'
})
export class ObserveDirective {
  /**
   * If fallback is set to true, we will consider the element observed to
   * always be in the viewport. Therefore, enterViewport will emit `true`.
   */
  @Input() fallBack = true;

  @Output() enterViewport = new EventEmitter();
  @Output() leaveViewport = new EventEmitter();

  observer: IntersectionObserver;

  constructor(el: ElementRef, private plateform: PlatformService) {
    if (this.plateform.isServer) {
      return;
    }
    if (!('IntersectionObserver' in window) && this.fallBack === true) {
      setTimeout(_ => this.enterViewport.emit(), 10); // Needed otherwise broke product comment
      return;
    }

    const options: IntersectionObserverInit = {};
    const callback: IntersectionObserverCallback = ([{ isIntersecting }]) =>
      isIntersecting ? this.enterViewport.emit() : this.leaveViewport.emit();

    this.observer = new IntersectionObserver(callback, options);
    this.observer.observe(el.nativeElement);
  }
}
